import { render, staticRenderFns } from "./ModalViewTemplates.vue?vue&type=template&id=636549d4&scoped=true&"
import script from "./ModalViewTemplates.vue?vue&type=script&lang=js&"
export * from "./ModalViewTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewTemplates.vue?vue&type=style&index=0&id=636549d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636549d4",
  null
  
)

export default component.exports